import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { selectCurrentUserProfile } from '@libs/store';
import { ffdNotesRoutePrefix } from '@libs/utils';
import { Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs';

export const activateGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(selectCurrentUserProfile).pipe(
    filter((profile) => profile != null),
    take(1),
    map((profile) => {
      if (profile!.ffdNotesBaaActivated) {
        return router.createUrlTree(ffdNotesRoutePrefix());
      }
      return true;
    }),
  );
};
